import { Link } from '../../../../../../components/blackrock/advisor-center/side-rail-navigation';

export interface IframeProps {
	relevantSearchParams: URLSearchParams;
	canOverrideIframeStyles: boolean;
	link: Link;
	iframeCss?: string;
	iframeTitle?: string;
	visible?: boolean;
	loadComplete: (
		ev: React.BaseSyntheticEvent<Event, HTMLIFrameElement, HTMLIFrameElement>
	) => void;
	isSideRail: boolean;
	sideRailWidth: number;
	scrollbarWidth: number;
}

export enum MessageType {
	IFRAME_VISIBILITY = 'IFrame visibility',
	REQUEST_IFRAME_VISIBILITY = 'Request IFrame visibility',
}
